import { render, staticRenderFns } from "./PlushieTagsList.vue?vue&type=template&id=3f8f2c45&scoped=true&"
import script from "./PlushieTagsList.vue?vue&type=script&lang=ts&"
export * from "./PlushieTagsList.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieTagsList.vue?vue&type=style&index=0&id=3f8f2c45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f2c45",
  null
  
)

export default component.exports